import { render } from "./Switch.vue?vue&type=template&id=bad910de&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=bad910de&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad910de"]])

export default __exports__